var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 79"},React.createElement("path",{"d":"M15,6H5.41l2.3-2.29A1,1,0,0,0,6.29,2.29l-4,4a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L5.41,8H15a5,5,0,0,1,0,10H3a1,1,0,0,0,0,2H15A7,7,0,0,0,15,6Z"})));
}

Back.defaultProps = {"style":{"fill":"#ffffff"},"viewBox":"0 0 24 30","x":"0px","y":"0px"};

module.exports = Back;

Back.default = Back;
